
export default function ExampleLogo() {
    return (
        <div className="exampleLogo">
            <div className="exampleLogoCard"></div>
        </div>
    )
}
